/* Daily Eyewear x Dawn : global behaviour */
(function () {
  'use strict';

  var DE = (window.DE = window.DE || {});

  /* ---------- Toast ---------- */
  DE.toast = function (title, text, isError) {
    var wrap = document.querySelector('.de-toast-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'de-toast-wrap';
      wrap.setAttribute('aria-live', 'polite');
      document.body.appendChild(wrap);
    }
    var el = document.createElement('div');
    el.className = 'de-toast' + (isError ? ' is-error' : '');
    el.innerHTML = '<strong></strong><span></span>';
    el.querySelector('strong').textContent = title || '';
    el.querySelector('span').textContent = text || '';
    wrap.appendChild(el);
    setTimeout(function () {
      el.style.transition = 'opacity .3s';
      el.style.opacity = '0';
      setTimeout(function () { el.remove(); }, 320);
    }, 3200);
  };

  /* ---------- Add to cart (feeds Dawn's cart drawer) ---------- */
  DE.addToCart = function (items, opts) {
    opts = opts || {};
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          throw new Error(res.description || res.message || 'Could not add to bag');
        }
        if (drawer && res.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else if (!drawer) {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return res;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'de-add', cartData: res }); } catch (e) {}
        }
        if (opts.toastTitle) DE.toast(opts.toastTitle, opts.toastText);
        return res;
      });
  };

  DE.setBusy = function (btn, busy) {
    if (!btn) return;
    btn.disabled = !!busy;
    btn.style.opacity = busy ? '0.7' : '';
    if (busy) btn.setAttribute('aria-busy', 'true');
    else btn.removeAttribute('aria-busy');
  };

  /* ---------- Scroll reveal ---------- */
  var io = null;
  DE.reveal = function (scope) {
    var els = (scope || document).querySelectorAll('.reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
    }
    els.forEach(function (el) { io.observe(el); });
  };

  /* ---------- Panels (search overlay, mobile menu) ---------- */
  function openPanel(name) {
    var panel = document.querySelector('[data-de-panel="' + name + '"]');
    if (!panel) return;
    panel.classList.remove('hidden');
    document.body.classList.add('de-lock');
    var input = panel.querySelector('[data-de-search-input]');
    if (input) setTimeout(function () { input.focus(); }, 30);
  }
  function closePanels() {
    document.querySelectorAll('[data-de-panel]').forEach(function (p) { p.classList.add('hidden'); });
    document.body.classList.remove('de-lock');
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-de-open]');
    if (opener) { e.preventDefault(); openPanel(opener.getAttribute('data-de-open')); return; }
    if (e.target.closest('[data-de-close]')) { e.preventDefault(); closePanels(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanels(); });

  /* ---------- Predictive search ---------- */
  var searchTimer;
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-de-search-input]');
    if (!input) return;
    var panel = input.closest('[data-de-panel]');
    var out = panel.querySelector('[data-de-search-results]');
    var popular = panel.querySelector('[data-de-search-popular]');
    clearTimeout(searchTimer);
    var q = input.value.trim();
    if (q.length < 2) { out.innerHTML = ''; if (popular) popular.classList.remove('hidden'); return; }
    searchTimer = setTimeout(function () {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (popular) popular.classList.toggle('hidden', products.length > 0);
          if (!products.length) {
            out.innerHTML = '<p class="de-search-empty" style="color:#737373;font-size:14px">No frames found for &ldquo;' + q.replace(/</g, '&lt;') + '&rdquo;.</p>';
            return;
          }
          var html = '<p style="font-size:11px;letter-spacing:.2em;text-transform:uppercase;color:#a3a3a3;margin-bottom:16px">Products</p><div style="display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:16px">';
          products.forEach(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=300' : '';
            html += '<a href="' + p.url + '" style="display:block">' +
              '<span style="display:block;aspect-ratio:1/1;border:1px solid #f5f5f5;background:#fff">' +
              (img ? '<img src="' + img + '" alt="" style="width:100%;height:100%;object-fit:contain;padding:12px">' : '') +
              '</span><span style="display:block;margin-top:8px;font-weight:700;font-size:13px;text-transform:uppercase"></span></a>';
          });
          html += '</div>';
          out.innerHTML = html;
          var titles = out.querySelectorAll('a > span:last-child');
          products.forEach(function (p, i) { titles[i].textContent = p.title; });
        })
        .catch(function () { out.innerHTML = ''; });
    }, 220);
  });

  /* ---------- Header scroll state ---------- */
  function onScroll() {
    var h = document.querySelector('[data-de-header]');
    if (h) h.classList.toggle('is-scrolled', window.scrollY > 8);
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------- Product cards: strength chips + quick add ---------- */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-de-chip]');
    if (chip) {
      e.preventDefault();
      var group = chip.closest('[data-de-chips]');
      group.querySelectorAll('[data-de-chip]').forEach(function (c) {
        var on = c === chip;
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        c.classList.toggle('bg-black', on);
        c.classList.toggle('text-white', on);
        c.classList.toggle('border-black', on);
        c.classList.toggle('bg-white', !on);
        c.classList.toggle('text-black', !on);
        c.classList.toggle('border-neutral-300', !on);
      });
      return;
    }

    var add = e.target.closest('[data-de-quick-add]');
    if (add) {
      e.preventDefault();
      var card = add.closest('[data-de-card]');
      var selected = card.querySelector('[data-de-chip][aria-pressed="true"]');
      var id = selected ? selected.getAttribute('data-variant-id') : add.getAttribute('data-variant-id');
      if (!id) { DE.toast('Select a strength', 'Pick a strength to continue.', true); return; }
      var name = card.getAttribute('data-product-title');
      var strength = selected ? selected.getAttribute('data-value') : '';
      DE.setBusy(add, true);
      DE.addToCart([{ id: Number(id), quantity: 1 }], {
        toastTitle: 'Added to bag',
        toastText: name + (strength ? ' \u00b7 Strength ' + strength : '')
      })
        .catch(function (err) { DE.toast('Could not add', err.message, true); })
        .finally(function () { DE.setBusy(add, false); });
    }
  });

  /* ---------- Init ---------- */
  function init() { DE.reveal(); onScroll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) { DE.reveal(e.target); });
})();
